// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__1MjUl","loading":"Loader_loading__3j9hB"};